<template>
  <div name="hrms41e-detail">
    <div  class="box">
      <div class="box-body">
        <div class="detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRMS41EC2']['10'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.numappl }} - {{indexSelected.desc_numappl}}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRMS41EC2']['20'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dteappoi) }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRMS41EC2']['30'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{detail.tab1.detail.codform}} - {{ detail.tab1.detail.desc_codform }}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion"> 

        <detail-tab1 :labels="labels"
                     :labelsButton="labelsButton"
                     :detailTab1="detail.tab1"
                     :postHrms41eTab1Save="postHrms41eTab1Save" 
                     :indexSelected="indexSelected"
                     :searchIndex="searchIndex"/>


        <detail-tab2 :labels="labels"
                     :labelsButton="labelsButton"
                     :detailTab2="detail.tab2"
                     :indexSelected="indexSelected"
                     :detailTab2Columns="detailTab2Columns"/>
           
        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
        </div>

      </div>
    </div>


  </div>
</template>

<script>
import detailTab1 from 'components/hrms41e/detailTab1'
import detailTab2 from 'components/hrms41e/detailTab2'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms41e-detail',
  props: [ 'labels',
    'labelsButton',
    'nowLang',
    'toggle',
    'indexSelected',
    'searchIndex',
    'detail',
    'detailTab2Columns',
    'postHrms41eTab1Save'
  ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    detailTab1,
    detailTab2
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?030044f7